import Marquee from "react-fast-marquee";

const ITEMS = [
  "DIREITO TRABALHISTA",
  "CONSULTIVO",
  "CONTENCIOSO",
  "PALESTRAS & TREINAMENTOS",
  "COMPLIANCE",
  "ATENDIMENTO DIRETO",
];

export const EditorialMarquee = () => (
  <div className="bg-cream-dark border-y border-line py-6 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false}>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif text-2xl md:text-3xl text-ink/70 mx-10">
            {item}
          </span>
          <span className="w-2 h-2 rounded-full bg-teal-dark/40" />
        </span>
      ))}
    </Marquee>
  </div>
);
